import { reactive } from "vue";
//config
import ConfigManager from '@/config/ConfigManager.js';
//helper
import CacheHelper from "@/helper/CacheHelper";
//model
import { PlaceOrderModel } from "@/module/ShoppingCart/model/PlaceOrderModel.js"

const KEY_COOKIE_PLACEORDER = 'BzbsPlaceOrder';
let cache = new CacheHelper(ConfigManager.getCacheType());

const state = reactive({
    placeOrder: null,
});

const methods = {
    init: function () {
        state.placeOrder = new PlaceOrderModel();
        let cachePlaceOrder = cache.getCache(KEY_COOKIE_PLACEORDER);
        if (cachePlaceOrder) {
            state.placeOrder.updatePlaceOrder(cachePlaceOrder);
        }
        cache.setCache(KEY_COOKIE_PLACEORDER, state.placeOrder);
    },
    updatePlaceOrder: function() {
        cache.setCache(KEY_COOKIE_PLACEORDER, state.placeOrder);
    },
    removePlaceOrder: function() {
        cache.removeCache(KEY_COOKIE_PLACEORDER);
    }
};


export default {
    state: state,
    methods: methods,
}
